import * as THREE from 'three';
import { OutlinePass } from 'three/examples/jsm/Addons.js';

export function getOutlineEffect(window, scene, camera) {
    let outlinePass = new OutlinePass( new THREE.Vector2( window.innerWidth, window.innerHeight ), scene, camera );

    return outlinePass;
}

export function configureOutlineEffectSettings_Default(outlinePass) {
    outlinePass.edgeStrength = 8;
    outlinePass.edgeGlow = 3;
    outlinePass.edgeThickness = 3;
    outlinePass.visibleEdgeColor.set('#ffffff');

    const textureLoader = new THREE.TextureLoader();
    textureLoader.load("./three.js-master/examples/textures/tri_pattern.jpg", function(texture){
    if (texture) {
        outlinePass.patternTexture = texture;
        texture.wrapS = THREE.RepeatWrapping;
        texture.wrapT = THREE.RepeatWrapping;
    }
});
}

export function addOutlineBasedOnIntersections(intersections, outlinePass){
    outlinePass.selectedObjects = [];

    if(intersections.length > 0) {
        let firstObject = intersections[0].object;
        let objectName = firstObject.userData.name;

        if(objectName.includes("Interact")) {
            outlinePass.selectedObjects = [firstObject];
            document.body.style.cursor = 'pointer';
        }
        else if (objectName.includes("Back")) {
            document.body.style.cursor = 'pointer';
        }
        else if(!objectName.includes("Interact")) {
            document.body.style.cursor = 'auto';
        }
    }
}

export function addOutlineToModels(intersections, outlinePass, lodGroup){
    outlinePass.selectedObjects = [];

    if(intersections.length > 0) {
        let firstObject = intersections[0].object;
        let objectName = firstObject.userData.name;

        if(objectName.includes("Model")) {
            outlinePass.selectedObjects = [firstObject];
            document.body.style.cursor = 'pointer';
        }
        else if(objectName.includes("Link")) {
            document.body.style.cursor = 'pointer';
        }
        else if(objectName.includes("Back")) {
            document.body.style.cursor = 'pointer';
        }
        else {
            document.body.style.cursor = 'auto';
        }
    }
}

export function addOutlineTo2D(intersections, outlinePass){
    outlinePass.selectedObjects = [];

    if(intersections.length > 0) {
        let firstObject = intersections[0].object;
        let objectName = firstObject.userData.name;

        if(objectName.includes("Image")  && !objectName.includes("Background")) {
            outlinePass.selectedObjects = [firstObject];
            document.body.style.cursor = 'pointer';
        }
        else if(objectName.includes("Link")) {
            document.body.style.cursor = 'pointer';
        }
        else if(objectName.includes("Back")) {
            document.body.style.cursor = 'pointer';
        }
        else {
            document.body.style.cursor = 'auto';
        }
    }
}

export function addOutlineToAbout(intersections, outlinePass){
    outlinePass.selectedObjects = [];

    if(intersections.length > 0) {
        let firstObject = intersections[0].object;
        let objectName = firstObject.userData.name;

        if(objectName.includes("About") && !objectName.includes("Link")) {
            outlinePass.selectedObjects = [firstObject];
            document.body.style.cursor = 'pointer';
        }
        else if(objectName.includes("LinkB")) {
            document.body.style.cursor = 'pointer';
        }
        else if(objectName.includes("Back")) {
            document.body.style.cursor = 'pointer';
        }
        else {
            document.body.style.cursor = 'auto';
        }
    }
}

export function addOutlineToGames(intersections, outlinePass){
    outlinePass.selectedObjects = [];

    if(intersections.length > 0) {
        let firstObject = intersections[0].object;
        let objectName = firstObject.userData.name;

        if(objectName.includes("Game Case")) {
            outlinePass.selectedObjects = [firstObject];
            document.body.style.cursor = 'pointer';
        }
        else if(objectName.includes("Link")) {
            document.body.style.cursor = 'pointer';
        }
        else if(objectName.includes("Show")) {
            document.body.style.cursor = 'pointer';
        }
        else if(objectName.includes("Back")) {
            document.body.style.cursor = 'pointer';
        }
        else {
            document.body.style.cursor = 'auto';
        }
    }
}

export function addOutlineToInProg(intersections, outlinePass){
    
    outlinePass.selectedObjects = [];


    if(intersections.length > 0) {
        let firstObject = intersections[0].object;
        let objectName = firstObject.userData.name;

        if(objectName.includes("InProg")) {
            outlinePass.selectedObjects = [firstObject];
            document.body.style.cursor = 'pointer';
        }
        else if(objectName.includes("Link")) {
            document.body.style.cursor = 'pointer';
        }
        else if(objectName.includes("Back")) {
            document.body.style.cursor = 'pointer';
        }
        else {
            document.body.style.cursor = 'auto';
        }
    }
}